<template>
  <header class="topbar">
    <div class="inner">
      <router-link to="/home" class="logo">
        <span class="mark"><i class="ri-live-fill"></i></span>
        <span class="word">AcadaPower <b>Live</b></span>
      </router-link>
      <div class="right">
        <div class="clock" aria-hidden="true">
          <span>{{ time }}</span>
          <span class="dot"></span>
          <span class="date">{{ date }}</span>
        </div>
        <div class="account" ref="account">
          <button class="me" @click="open = !open" :aria-expanded="open" aria-label="Your account">
            <Avatar :name="name" :image="user.image" :size="34" />
            <i class="ri-arrow-down-s-line"></i>
          </button>
          <Transition name="pop">
            <div class="menu" v-if="open">
              <div class="who">
                <Avatar :name="name" :image="user.image" :size="40" />
                <div>
                  <strong>{{ name || "You" }}</strong>
                  <small>{{ user.email }}</small>
                </div>
              </div>
              <div class="menu-sep"></div>
              <button class="menu-item danger" @click="signOut">
                <i class="ri-logout-box-r-line"></i> Sign out
              </button>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Avatar from "@/components/ui/Avatar.vue";
import { auth } from "@/api";
import { currentUser, fullName, forget } from "@/session";

export default {
  name: "Navbar",
  components: { Avatar },
  data() {
    return { time: "", date: "", timer: null, open: false, user: currentUser() };
  },
  computed: {
    name() {
      return fullName(this.user);
    },
  },
  mounted() {
    this.tick();
    this.timer = setInterval(this.tick, 15000);
    document.addEventListener("click", this.outside);
  },
  beforeUnmount() {
    clearInterval(this.timer);
    document.removeEventListener("click", this.outside);
  },
  methods: {
    tick() {
      const now = new Date();
      this.time = now.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
      this.date = now.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
    },
    outside(e) {
      if (this.open && this.$refs.account && !this.$refs.account.contains(e.target)) this.open = false;
    },
    async signOut() {
      // Signed out here whatever the server says: a dead session is gone too.
      try {
        await auth.logout();
      } catch (e) {
        // nothing to do
      }
      forget();
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  position: sticky;
  top: 0;
  z-index: 50;
  height: 64px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--line);
}

.inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.25rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: -0.01em;

  .mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--brand), var(--accent));
    color: #fff;
    font-size: 1.1rem;
  }

  b {
    color: var(--brand);
  }

  @media (max-width: 420px) {
    .word {
      display: none;
    }
  }
}

.right {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.clock {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--ink-2);
  font-variant-numeric: tabular-nums;

  .dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: var(--ink-3);
  }

  @media (max-width: 640px) {
    .dot,
    .date {
      display: none;
    }
  }
}

.account {
  position: relative;
}

.me {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  padding: 3px 6px 3px 3px;
  border: 1px solid var(--line);
  border-radius: 999px;
  background: var(--surface);
  cursor: pointer;
  color: var(--ink-3);

  &:hover {
    border-color: var(--line-2);
  }
}

.menu {
  right: 0;
  top: calc(100% + 8px);
  width: 260px;

  .who {
    display: flex;
    align-items: center;
    gap: 0.7rem;
    padding: 0.5rem;

    strong {
      display: block;
      font-size: 0.92rem;
    }

    small {
      display: block;
      font-size: 0.8rem;
      color: var(--ink-3);
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 170px;
    }
  }
}
</style>
